import React from "react";

function SpanishPolicy() {
  return (
    <section className="max-w-4xl mx-auto px-4 py-10 text-gray-800 text-left">
      <h1 className="text-3xl font-bold mb-4">Polar Water LLC / Polar Water Filtration - Política de Privacidad</h1>
      <p className="text-sm text-gray-500 mb-8">
        Fecha de vigencia: <strong>02/04/2024</strong> <br /> Última actualización: <strong>05/15/2024</strong>
      </p>

      <p className="mb-4">
      <strong>Polar Water LLC, también conocida como Polar Water Filtration</strong> ("nosotros", "nuestro" o "nos"), respeta su privacidad. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos su información cuando interactúa con nosotros a través de nuestro sitio web, anuncios y formularios de contacto en plataformas como Meta (Facebook e Instagram), Google Ads y Yelp.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2">1. Información que Recopilamos</h2>
      <ul className="list-disc list-inside space-y-2 mb-4">
      <p>Cuando completa un formulario, solicita información o se comunica con nosotros, podemos recopilar:</p>
        <li>
          <strong>Información personal</strong> – Su nombre, número de teléfono, dirección de correo electrónico y código postal.
        </li>
        <li>
          <strong>Preferencias de servicio</strong> – Si es propietario o inquilino, sus preocupaciones sobre el agua y su interés en nuestros productos.
        </li>
        <li>
          <strong>Interacciones con el sitio web y anuncios</strong> – Información sobre cómo interactúa con nuestros anuncios y sitio web.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">2. Cómo Usamos Su Información</h2>
      <ul className="list-disc list-inside space-y-2 mb-4">
      <p>Utilizamos los datos recopilados para:</p>
        <li>Proporcionar soluciones personalizadas de filtración de agua.</li>
        <li>Responder a consultas y programar consultas.</li>
        <li>Mejorar nuestra publicidad, servicio al cliente y experiencia en el sitio web.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">3. Protección y Compartición de Datos</h2>
      <ul className="list-disc list-inside space-y-2 mb-4">
        <li>No vendemos, alquilamos ni compartimos su información personal con terceros.</li>
        <li>Sus datos se almacenan de manera segura y se usan únicamente para fines comerciales de Polar Water.</li>
        <li>Podemos utilizar herramientas publicitarias de Google, Meta o Yelp para volver a orientar anuncios a usuarios interesados.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">4. Sus Opciones y Derechos</h2>
      <ul className="list-disc list-inside space-y-2 mb-4">
      <p>Usted puede:</p>
        <li><strong>Optar por no recibir comunicaciones</strong> – Cancelar la suscripción a correos electrónicos o solicitar la eliminación de nuestras listas de contacto.</li>
        <li><strong>Solicitar la eliminación de sus datos</strong> – Puede contactarnos para solicitar la eliminación de su información personal de nuestro sistema.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2">5. Contáctenos</h2>
      <p className="mb-2">
        Si tiene alguna pregunta o desea gestionar sus datos, contáctenos en:
      </p>
      <p className="mb-1">
        📧 Correo electrónico:{" "}
        <a
          href="mailto:polarwaterllc@gmail.com"
          className="text-blue-600 hover:underline"
        >
          polarwaterllc@gmail.com
        </a>
      </p>
      <p>📞 Teléfono: (951) 212-5633</p>
    </section>
  );
}

export default SpanishPolicy;
